import LinkWrapper from 'UI/components/LinkWrapper';
import { routes } from 'utils/routes';
import styles from './styles.module.scss';
import Svg from '../Svg';

const AiEngineeringPodBadge = () => (
  <LinkWrapper
    path={routes.aiManagedPod.path}
    className={styles.badge}
  >
    <div className={styles.innerBadge}>
      <span className={styles.title}>AI engineering pod</span>
      <span className={styles.price}>$16k</span>
      <span className={styles.time}>/month</span>
      <span className={styles.divider} />
      <span className={styles.subtitle}>
        <Svg
          type="coinsStacked"
          className={styles.iconPrice}
        />
        Fixed
        <br />
        monthly cost.
      </span>
      <span
        className={styles.arrow}
      >
        <Svg
          type="arrowRight"
          className={styles.icon}
        />
      </span>
    </div>
  </LinkWrapper>
);

export default AiEngineeringPodBadge;
